import { render, staticRenderFns } from "./epistolize.vue?vue&type=template&id=d2fab7ce&scoped=true"
import script from "./epistolize.vue?vue&type=script&lang=js"
export * from "./epistolize.vue?vue&type=script&lang=js"
import style0 from "./epistolize.vue?vue&type=style&index=0&id=d2fab7ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../usr/local/node_16.9.1/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2fab7ce",
  null
  
)

export default component.exports